// import { useState, useEffect } from 'react';
// import EditIcon from '../../Assets/Images/CommanImages/GPenz.png';
// import { API_BASE_URL } from "../../Config/Config";

// const Profile = ({ setPagePath, dataClient }) => {
//   const [profileData, setProfileData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [isEditingPassword, setIsEditingPassword] = useState(false);
//   const [passwordData, setPasswordData] = useState({
//     currentPassword: '',
//     newPassword: '',
//     confirmPassword: ''
//   });
//   const [passwordError, setPasswordError] = useState('');
//   const [saving, setSaving] = useState(false);
//   const [successMessage, setSuccessMessage] = useState('');

//   useEffect(() => {
//     setPagePath('Profile');
//     fetchProfileData();
//   }, []);

//   const fetchProfileData = async () => {
//     setLoading(true);
//     try {
//       const token = localStorage.getItem('other');
//       const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id ?? 1;
//       const userId = dataClient?.client_schema_name?.[6]?.[0]?.user_id ?? 4;

//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/client_landing_page_info_web/?client_id=${clientId}&user_id=${userId}`,
//         {
//           headers: {
//             accept: 'application/json',
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );
//       const result = await response.json();
      
//       if (result.client_schema_name && result.client_schema_name[6]) {
//         setProfileData(result.client_schema_name[6][0]);
//       }
//     } catch (error) {
//       console.error('Error fetching profile:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handlePasswordChange = (field, value) => {
//     setPasswordData(prev => ({ ...prev, [field]: value }));
//     setPasswordError('');
//     setSuccessMessage('');
//   };

//   const handleEditPassword = () => {
//     setIsEditingPassword(true);
//     setPasswordError('');
//     setSuccessMessage('');
//   };

//   const handleCancelEdit = () => {
//     setIsEditingPassword(false);
//     setPasswordData({
//       currentPassword: '',
//       newPassword: '',
//       confirmPassword: ''
//     });
//     setPasswordError('');
//     setSuccessMessage('');
//   };

//   const handleSavePassword = async () => {
//     // Validation
//     if (!passwordData.currentPassword || !passwordData.newPassword || !passwordData.confirmPassword) {
//       setPasswordError('All fields are required');
//       return;
//     }

//     if (passwordData.newPassword !== passwordData.confirmPassword) {
//       setPasswordError('New password and confirm password do not match');
//       return;
//     }

//     if (passwordData.newPassword.length < 6) {
//       setPasswordError('Password must be at least 6 characters long');
//       return;
//     }

//     setSaving(true);
//     setPasswordError('');

//     try {
//       const token = localStorage.getItem('other');
//       const userId = profileData?.user_id ?? 4;
//       const clientId = profileData?.client_id ?? 1;
//       const modifiedBy = profileData?.user_name ?? 'user';

//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/change-password?user_id=${userId}&client_id=${clientId}&old_password=${encodeURIComponent(passwordData.currentPassword)}&new_password=${encodeURIComponent(passwordData.newPassword)}&modified_by=${modifiedBy}`,
//         {
//           method: 'PATCH',
//           headers: {
//             accept: 'application/json',
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       const result = await response.json();

//       if (result.status === 200) {
//         setSuccessMessage('Password changed successfully!');
//         setTimeout(() => {
//           handleCancelEdit();
//         }, 2000);
//       } else {
//         setPasswordError(result.message || 'Failed to change password');
//       }
//     } catch (error) {
//       console.error('Error changing password:', error);
//       setPasswordError('An error occurred while changing password');
//     } finally {
//       setSaving(false);
//     }
//   };

//   const getFullName = () => {
//     if (!profileData) return '';
//     const parts = [
//       profileData.emp_first_name,
//       profileData.emp_middle_name,
//       profileData.emp_last_name
//     ].filter(Boolean);
//     return parts.join(' ');
//   };

//   const getInitials = () => {
//     if (!profileData) return 'U';
//     const firstName = profileData.emp_first_name || '';
//     const lastName = profileData.emp_last_name || '';
//     return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
//   };

//   const getProfileImageUrl = () => {
//     // Check for profile image in profileData
//     // Adjust the property name based on your API response
//     return profileData?.profile_image || profileData?.profile_picture || profileData?.avatar_url || null;
//   };

//   return (
//     <div style={styles.container}>
//       <style>{`
//         .profile-card {
//           background-color: #f3f4f6;
//           border: 1px solid #d1d5db;
//           border-radius: 8px;
//           padding: 24px;
//           margin-bottom: 16px;
//           position: relative;
//         }
//         .input-field-profile {
//           width: 100%;
//           background-color: white;
//           border: 1px solid #d1d5db;
//           border-radius: 4px;
//           padding: 8px 12px;
//           font-size: 14px;
//           color: #1f2937;
//         }
//         .input-field-profile:focus {
//           outline: none;
//           // border-color: #f97316;
//           // box-shadow: 0 0 0 1px #f97316;
//         }
//         .input-field-profile.error {
//           border-color: #ef4444;
//         }
//         .error-message-profile-page {
//           color: #ef4444;
//           font-size: 12px;
//           margin-top: 4px;
//           display: block;
//         }
//         .success-message {
//           color: #10b981;
//           font-size: 12px;
//           margin-top: 4px;
//         }
//         .profile-avatar {
//           width: 80px;
//           height: 80px;
//           border-radius: 50%;
//           // background: linear-gradient(135deg, #ffffffff 0%, #ff5900ff 100%);
//           background: #fa4741;
//           // background: #ffbd20;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-size: 32px;
//           font-weight: 600;
//           color: white;
//           margin-bottom: 16px;
//           overflow: hidden;
//         }
//         .profile-avatar img {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//         }
//         .profile-edit-icon {
//           position: absolute;
//           top: 24px;
//           right: 24px;
//           cursor: pointer;
//           // opacity: 0.7;
//           // transition: opacity 0.2s;
//         }
//         // .profile-edit-icon:hover {
//         //   opacity: 1;
//         // }
//       `}</style>

//       <div style={styles.content}>
//         {loading ? (
//           <div style={styles.emptyState}>
//             <p>Loading profile...</p>
//           </div>
//         ) : (
//           <>
//             {/* Profile Information Card */}
//             <div className="profile-card">
//               <span
//                 className="profile-edit-icon"
//                 title="Edit profile"
//               >
//                 <img src={EditIcon} alt="Edit" />
//               </span>
              
//               <div style={styles.profileHeader}>
//                 <div style={styles.profileLeft}>
//                   <div className="profile-avatar">
//                     {getProfileImageUrl() ? (
//                       <img src={getProfileImageUrl()} alt="Profile" />
//                     ) : (
//                       getInitials()
//                     )}
//                   </div>
//                   <div style={styles.profileInfo}>
//                     <h2 style={styles.profileName}>{getFullName()}</h2>
//                     <div style={styles.profileDetails}>
//                       <div style={styles.detailRow}>
//                         <span style={styles.detailLabel}>Staff Number:</span>
//                         <span style={styles.detailValue}>{profileData?.staff_number}</span>
//                       </div>
//                       <div style={styles.detailRow}>
//                         <span style={styles.detailLabel}>Username:</span>
//                         <span style={styles.detailValue}>{profileData?.user_name}</span>
//                       </div>
//                       <div style={styles.detailRow}>
//                         <span style={styles.detailLabel}>Organization:</span>
//                         <span style={styles.detailValue}>{profileData?.client_display_name}</span>
//                       </div>
//                       <div style={styles.detailRow}>
//                         <span style={styles.detailLabel}>Branch:</span>
//                         <span style={styles.detailValue}>{profileData?.br_display_name}</span>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Change Password Card */}
//             <div className="profile-card">
//               <div style={styles.cardContent}>
//                 <div style={styles.cardLeft}>
//                   <h3 style={styles.cardTitle}>Change Password</h3>
//                   <p style={styles.cardSubtitle}>Update your account password</p>

//                   {isEditingPassword ? (
//                     <div style={styles.editContainer}>
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>Current Password</label>
//                         <input
//                           type="password"
//                           value={passwordData.currentPassword}
//                           onChange={(e) => handlePasswordChange('currentPassword', e.target.value)}
//                           className="input-field-profile"
//                           placeholder="Enter current password"
//                           autoComplete="new-password"
//                         />
//                       </div>
                      
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>New Password</label>
//                         <input
//                           type="password"
//                           value={passwordData.newPassword}
//                           onChange={(e) => handlePasswordChange('newPassword', e.target.value)}
//                           className="input-field-profile"
//                           placeholder="Enter new password"
//                           autoComplete="new-password"
//                         />
//                       </div>

//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>Confirm Password</label>
//                         <input
//                           type="text"
//                           value={passwordData.confirmPassword}
//                           onChange={(e) => handlePasswordChange('confirmPassword', e.target.value)}
//                           className={`input-field-profile ${passwordData.confirmPassword && passwordData.newPassword && passwordData.confirmPassword !== passwordData.newPassword ? 'error' : ''}`}
//                           placeholder="Confirm new password"
//                           autoComplete="off"
//                         />
//                         {passwordData.confirmPassword && passwordData.newPassword && 
//                          passwordData.confirmPassword !== passwordData.newPassword && (
//                           <div className="error-message-profile-page">
//                             Passwords do not match
//                           </div>
//                         )}
//                       </div>

//                       {passwordError && (
//                         <div className="error-message-profile-page" style={{ marginTop: '-8px' }}>{passwordError}</div>
//                       )}
                      
//                       {successMessage && (
//                         <div className="success-message">{successMessage}</div>
//                       )}

//                       <div style={styles.buttonGroup}>
//                         <button
//                           onClick={handleSavePassword}
//                           disabled={saving || !passwordData.currentPassword || 
//                                    !passwordData.newPassword || !passwordData.confirmPassword ||
//                                    passwordData.newPassword !== passwordData.confirmPassword}
//                           className="create-test-section-btn"
//                           style={{marginLeft: '0px', marginRight: '0px'}}
//                         >
//                           {saving ? 'SAVING...' : 'SAVE'}
//                         </button>
//                         <button
//                           onClick={handleCancelEdit}
//                           disabled={saving}
//                           className="create-test-section-btn"
//                           style={{marginLeft: '0px', marginRight: '0px'}}
//                         >
//                           CANCEL
//                         </button>
//                       </div>
//                     </div>
//                   ) : (
//                     <div style={styles.valueDisplay}>
//                       <span style={styles.valueText}>••••••••</span>
//                     </div>
//                   )}
//                 </div>

//                 {!isEditingPassword && (
//                   <span
//                     onClick={handleEditPassword}
//                     style={{ cursor: 'pointer' }}
//                     title="Change password"
//                   >
//                     <img src={EditIcon} alt="Edit" />
//                   </span>
//                 )}
//               </div>
//             </div>
//           </>
//         )}
//       </div>
//     </div>
//   );
// };

// const styles = {
//   container: {
//     minHeight: '100vh',
//     backgroundColor: 'white',
//     color: '#1f2937',
//     paddingLeft: '40px',
//   },
//   content: {
//     maxWidth: '1200px',
//     paddingTop: '30px',
//     paddingLeft: '20px',
//   },
//   emptyState: {
//     textAlign: 'center',
//     color: '#6b7280',
//     padding: '48px 0',
//   },
//   profileHeader: {
//     display: 'flex',
//     alignItems: 'flex-start',
//     justifyContent: 'space-between',
//   },
//   profileLeft: {
//     display: 'flex',
//     gap: '24px',
//     alignItems: 'center',
//   },
//   profileInfo: {
//     flex: 1,
//   },
//   profileName: {
//     fontSize: '24px',
//     fontWeight: '600',
//     color: '#1f2937',
//     marginBottom: '16px',
//   },
//   profileDetails: {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '8px',
//   },
//   detailRow: {
//     display: 'flex',
//     gap: '8px',
//     fontSize: '14px',
//   },
//   detailLabel: {
//     fontWeight: '500',
//     color: '#6b7280',
//     minWidth: '120px',
//   },
//   detailValue: {
//     color: '#1f2937',
//   },
//   cardContent: {
//     display: 'flex',
//     alignItems: 'flex-start',
//     justifyContent: 'space-between',
//   },
//   cardLeft: {
//     flex: 1,
//   },
//   cardTitle: {
//     fontSize: '18px',
//     fontWeight: '500',
//     color: '#1f2937',
//     marginBottom: '8px',
//   },
//   cardSubtitle: {
//     fontSize: '14px',
//     color: '#6b7280',
//     marginBottom: '16px',
//   },
//   editContainer: {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '16px',
//     maxWidth: '400px',
//   },
//   inputGroup: {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '8px',
//   },
//   label: {
//     fontSize: '14px',
//     fontWeight: '500',
//     color: '#374151',
//   },
//   buttonGroup: {
//     display: 'flex',
//     gap: '12px',
//     marginTop: '8px',
//   },
//   valueDisplay: {
//     fontSize: '14px',
//     color: '#374151',
//   },
//   valueText: {
//     fontSize: '20px',
//     letterSpacing: '2px',
//     color: '#9ca3af',
//   },
// };

// export default Profile;




































// TO SET NORMAL PASSWORDS

// import { useState, useEffect } from 'react';
// import EditIcon from '../../Assets/Images/CommanImages/GPenz.png';
// import { API_BASE_URL } from "../../Config/Config";

// const Profile = ({ setPagePath, dataClient }) => {
//   const [profileData, setProfileData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [isEditingPassword, setIsEditingPassword] = useState(false);
//   const [passwordData, setPasswordData] = useState({
//     currentPassword: '',
//     newPassword: '',
//     confirmPassword: ''
//   });
//   const [passwordError, setPasswordError] = useState('');
//   const [saving, setSaving] = useState(false);
//   const [successMessage, setSuccessMessage] = useState('');

//   useEffect(() => {
//     setPagePath('Profile');
//     fetchProfileData();
//   }, []);

//   const fetchProfileData = async () => {
//     setLoading(true);
//     try {
//       const token = localStorage.getItem('other');
//       const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id ?? 1;
//       const userId = dataClient?.client_schema_name?.[6]?.[0]?.user_id ?? 4;

//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/client_landing_page_info_web/?client_id=${clientId}&user_id=${userId}`,
//         {
//           headers: {
//             accept: 'application/json',
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );
//       const result = await response.json();
      
//       if (result.client_schema_name && result.client_schema_name[6]) {
//         setProfileData(result.client_schema_name[6][0]);
//       }
//     } catch (error) {
//       console.error('Error fetching profile:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handlePasswordChange = (field, value) => {
//     setPasswordData(prev => ({ ...prev, [field]: value }));
//     setPasswordError('');
//     setSuccessMessage('');
//   };

//   const handleEditPassword = () => {
//     setIsEditingPassword(true);
//     setPasswordError('');
//     setSuccessMessage('');
//   };

//   const handleCancelEdit = () => {
//     setIsEditingPassword(false);
//     setPasswordData({
//       currentPassword: '',
//       newPassword: '',
//       confirmPassword: ''
//     });
//     setPasswordError('');
//     setSuccessMessage('');
//   };

//   const handleSavePassword = async () => {
//     // Validation
//     if (!passwordData.currentPassword || !passwordData.newPassword || !passwordData.confirmPassword) {
//       setPasswordError('All fields are required');
//       return;
//     }

//     if (passwordData.newPassword !== passwordData.confirmPassword) {
//       setPasswordError('New password and confirm password do not match');
//       return;
//     }

//     if (passwordData.newPassword.length < 6) {
//       setPasswordError('Password must be at least 6 characters long');
//       return;
//     }

//     setSaving(true);
//     setPasswordError('');

//     try {
//       const token = localStorage.getItem('other');
//       const userId = profileData?.user_id ?? 4;
//       const clientId = profileData?.client_id ?? 1;
//       const modifiedBy = profileData?.user_name ?? 'user';

//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/change-password?user_id=${userId}&client_id=${clientId}&old_password=${encodeURIComponent(passwordData.currentPassword)}&new_password=${encodeURIComponent(passwordData.newPassword)}&modified_by=${modifiedBy}`,
//         {
//           method: 'PATCH',
//           headers: {
//             accept: 'application/json',
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       const result = await response.json();

//       if (result.status === 200) {
//         setSuccessMessage('Password changed successfully!');
//         setTimeout(() => {
//           handleCancelEdit();
//         }, 2000);
//       } else {
//         setPasswordError(result.message || 'Failed to change password');
//       }
//     } catch (error) {
//       console.error('Error changing password:', error);
//       setPasswordError('An error occurred while changing password');
//     } finally {
//       setSaving(false);
//     }
//   };

//   const getFullName = () => {
//     if (!profileData) return '';
//     const parts = [
//       profileData.emp_first_name,
//       profileData.emp_middle_name,
//       profileData.emp_last_name
//     ].filter(Boolean);
//     return parts.join(' ');
//   };

//   const getInitials = () => {
//     if (!profileData) return 'U';
//     const firstName = profileData.emp_first_name || '';
//     const lastName = profileData.emp_last_name || '';
//     return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
//   };

//   const getProfileImageUrl = () => {
//     // Check for profile image in profileData
//     // Adjust the property name based on your API response
//     return profileData?.profile_image || profileData?.profile_picture || profileData?.avatar_url || null;
//   };

//   return (
//     <div style={styles.container}>
//       <style>{`
//         .profile-card {
//           background-color: #f3f4f6;
//           border: 1px solid #d1d5db;
//           border-radius: 8px;
//           padding: 24px;
//           margin-bottom: 16px;
//           position: relative;
//         }
//         .profile-card:first-child {
//           margin-top: 60px;
//         }
//         .input-field-profile {
//           width: 100%;
//           background-color: white;
//           border: 1px solid #d1d5db;
//           border-radius: 4px;
//           padding: 8px 12px;
//           font-size: 14px;
//           color: #1f2937;
//         }
//         .input-field-profile:focus {
//           outline: none;
//           // border-color: #f97316;
//           // box-shadow: 0 0 0 1px #f97316;
//         }
//         .input-field-profile.error {
//           border-color: #ef4444;
//         }
//         .error-message-profile-page {
//           color: #ef4444;
//           font-size: 12px;
//           margin-top: 4px;
//           display: block;
//         }
//         .success-message {
//           color: #10b981;
//           font-size: 12px;
//           margin-top: 4px;
//         }
//         .profile-avatar {
//           width: 100px;
//           height: 100px;
//           border-radius: 50%;
//           // background: linear-gradient(135deg, #f97316 0%, #ea580c 100%);
//           background: #ef4444;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-size: 36px;
//           font-weight: 600;
//           color: white;
//           overflow: hidden;
//           border: 4px solid white;
//           position: absolute;
//           top: -50px;
//           left: 24px;
//         }
//         .profile-avatar img {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//         }
//         .profile-edit-icon {
//           position: absolute;
//           top: 24px;
//           right: 24px;
//           cursor: pointer;
//           // opacity: 0.7;
//           // transition: opacity 0.2s;
//         }
//         // .profile-edit-icon:hover {
//         //   opacity: 1;
//         // }
//       `}</style>

//       <div style={styles.content}>
//         {loading ? (
//           <div style={styles.emptyState}>
//             <p>Loading profile...</p>
//           </div>
//         ) : (
//           <>
//             {/* Profile Information Card */}
//             <div className="profile-card">
//               {/* <span
//                 className="profile-edit-icon"
//                 title="Edit profile"
//               >
//                 <img src={EditIcon} alt="Edit" />
//               </span> */}
              
//               <div style={styles.profileHeader}>
//                 <div style={styles.profileLeft}>
//                   <div className="profile-avatar">
//                     {getProfileImageUrl() ? (
//                       <img src={getProfileImageUrl()} alt="Profile" />
//                     ) : (
//                       getInitials()
//                     )}
//                   </div>
//                   <div style={styles.profileInfo}>
//                     <h2 style={styles.profileName}>{getFullName()}</h2>
//                     <div style={styles.profileDetails}>
//                       <div style={styles.detailRow}>
//                         <span style={styles.detailLabel}>Staff Number:</span>
//                         <span style={styles.detailValue}>{profileData?.staff_number}</span>
//                       </div>
//                       <div style={styles.detailRow}>
//                         <span style={styles.detailLabel}>Username:</span>
//                         <span style={styles.detailValue}>{profileData?.user_name}</span>
//                       </div>
//                       <div style={styles.detailRow}>
//                         <span style={styles.detailLabel}>Designation:</span>
//                         <span style={styles.detailValue}>-</span>
//                       </div>
//                       <div style={styles.detailRow}>
//                         <span style={styles.detailLabel}>Department:</span>
//                         <span style={styles.detailValue}>-</span>
//                       </div>
//                       <div style={styles.detailRow}>
//                         <span style={styles.detailLabel}>Manager Name:</span>
//                         <span style={styles.detailValue}>-</span>
//                       </div>
//                       <div style={styles.detailRow}>
//                         <span style={styles.detailLabel}>Mobile Number:</span>
//                         <span style={styles.detailValue}>-</span>
//                       </div>
//                       <div style={styles.detailRow}>
//                         <span style={styles.detailLabel}>Email:</span>
//                         <span style={styles.detailValue}>-</span>
//                       </div>

//                       {/* <div style={styles.detailRow}>
//                         <span style={styles.detailLabel}>Organization:</span>
//                         <span style={styles.detailValue}>{profileData?.client_display_name}</span>
//                       </div> */}
//                       <div style={styles.detailRow}>
//                         <span style={styles.detailLabel}>Base Branch:</span>
//                         <span style={styles.detailValue}>{profileData?.br_display_name}</span>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Change Password Card */}
//             <div className="profile-card">
//               <div style={styles.cardContent}>
//                 <div style={styles.cardLeft}>
//                   <h3 style={styles.cardTitle}>Change Password</h3>
//                   <p style={styles.cardSubtitle}>Update your account password</p>

//                   {isEditingPassword ? (
//                     <div style={styles.editContainer}>
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>Current Password</label>
//                         <input
//                           type="password"
//                           value={passwordData.currentPassword}
//                           onChange={(e) => handlePasswordChange('currentPassword', e.target.value)}
//                           className="input-field-profile"
//                           placeholder="Enter current password"
//                           autoComplete="new-password"
//                         />
//                       </div>
                      
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>New Password</label>
//                         <input
//                           type="password"
//                           value={passwordData.newPassword}
//                           onChange={(e) => handlePasswordChange('newPassword', e.target.value)}
//                           className="input-field-profile"
//                           placeholder="Enter new password"
//                           autoComplete="new-password"
//                         />
//                       </div>

//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>Confirm Password</label>
//                         <input
//                           type="text"
//                           value={passwordData.confirmPassword}
//                           onChange={(e) => handlePasswordChange('confirmPassword', e.target.value)}
//                           className={`input-field-profile ${passwordData.confirmPassword && passwordData.newPassword && passwordData.confirmPassword !== passwordData.newPassword ? 'error' : ''}`}
//                           placeholder="Confirm new password"
//                           autoComplete="off"
//                         />
//                         {passwordData.confirmPassword && passwordData.newPassword && 
//                          passwordData.confirmPassword !== passwordData.newPassword && (
//                           <div className="error-message-profile-page">
//                             Passwords do not match
//                           </div>
//                         )}
//                       </div>

//                       {passwordError && (
//                         <div className="error-message-profile-page" style={{ marginTop: '-8px' }}>{passwordError}</div>
//                       )}
                      
//                       {successMessage && (
//                         <div className="success-message">{successMessage}</div>
//                       )}

//                       <div style={styles.buttonGroup}>
//                         <button
//                           onClick={handleSavePassword}
//                           disabled={saving || !passwordData.currentPassword || 
//                                    !passwordData.newPassword || !passwordData.confirmPassword ||
//                                    passwordData.newPassword !== passwordData.confirmPassword}
//                           className="create-test-section-btn"
//                           style={{marginLeft: '0px', marginRight: '0px'}}
//                         >
//                           {saving ? 'SAVING...' : 'SAVE'}
//                         </button>
//                         <button
//                           onClick={handleCancelEdit}
//                           disabled={saving}
//                           className="create-test-section-btn"
//                           style={{marginLeft: '0px', marginRight: '0px'}}
//                         >
//                           CANCEL
//                         </button>
//                       </div>
//                     </div>
//                   ) : (
//                     <div style={styles.valueDisplay}>
//                       <span style={styles.valueText}>••••••••</span>
//                     </div>
//                   )}
//                 </div>

//                 {!isEditingPassword && (
//                   <span
//                     onClick={handleEditPassword}
//                     style={{ cursor: 'pointer' }}
//                     title="Change password"
//                   >
//                     <img src={EditIcon} alt="Edit" />
//                   </span>
//                 )}
//               </div>
//             </div>
//           </>
//         )}
//       </div>
//     </div>
//   );
// };

// const styles = {
//   container: {
//     minHeight: '100vh',
//     backgroundColor: 'white',
//     color: '#1f2937',
//     paddingLeft: '40px',
//   },
//   content: {
//     maxWidth: '1200px',
//     paddingTop: '30px',
//     paddingLeft: '20px',
//   },
//   emptyState: {
//     textAlign: 'center',
//     color: '#6b7280',
//     padding: '48px 0',
//   },
//   profileHeader: {
//     display: 'flex',
//     alignItems: 'flex-start',
//     justifyContent: 'space-between',
//   },
//   profileLeft: {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '16px',
//     width: '100%',
//   },
//   profileInfo: {
//     flex: 1,
//     marginTop: '50px',
//   },
//   profileName: {
//     fontSize: '24px',
//     fontWeight: '600',
//     color: '#1f2937',
//     marginBottom: '16px',
//   },
//   profileDetails: {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '8px',
//   },
//   detailRow: {
//     display: 'flex',
//     gap: '8px',
//     fontSize: '14px',
//   },
//   detailLabel: {
//     fontWeight: '500',
//     color: '#6b7280',
//     minWidth: '120px',
//   },
//   detailValue: {
//     color: '#1f2937',
//   },
//   cardContent: {
//     display: 'flex',
//     alignItems: 'flex-start',
//     justifyContent: 'space-between',
//   },
//   cardLeft: {
//     flex: 1,
//   },
//   cardTitle: {
//     fontSize: '18px',
//     fontWeight: '500',
//     color: '#1f2937',
//     marginBottom: '8px',
//   },
//   cardSubtitle: {
//     fontSize: '14px',
//     color: '#6b7280',
//     marginBottom: '16px',
//   },
//   editContainer: {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '16px',
//     maxWidth: '400px',
//   },
//   inputGroup: {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '8px',
//   },
//   label: {
//     fontSize: '14px',
//     fontWeight: '500',
//     color: '#374151',
//   },
//   buttonGroup: {
//     display: 'flex',
//     gap: '12px',
//     marginTop: '8px',
//   },
//   valueDisplay: {
//     fontSize: '14px',
//     color: '#374151',
//   },
//   valueText: {
//     fontSize: '20px',
//     letterSpacing: '2px',
//     color: '#9ca3af',
//   },
// };

// export default Profile;


























import { useState, useEffect } from 'react';
import EditIcon from '../../Assets/Images/CommanImages/GPenz.png';
import { API_BASE_URL } from "../../Config/Config";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import "./profile.css";
import EndPoints from '../../Api/Endpoints';


const Profile = ({ setPagePath, dataClient, setIsLoggedOut, setAuthenticated }) => {
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isEditingPassword, setIsEditingPassword] = useState(false);
  const [passwordData, setPasswordData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [passwordError, setPasswordError] = useState('');
  const [newPasswordError, setNewPasswordError] = useState('');
  const [saving, setSaving] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);


  useEffect(() => {
    setPagePath('Profile');
    fetchProfileData();
  }, []);

  const fetchProfileData = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('other');
      const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id ?? 1;
      const userId = dataClient?.client_schema_name?.[6]?.[0]?.user_id ?? 4;
      const clientBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;

      const response = await fetch(
        `${EndPoints.CLIENT_LANDING_PAGE_INFO_V2}?client_id=${clientId}&user_id=${userId}&client_branch_id=${clientBranchId}`,
        {
          headers: {
            accept: 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const result = await response.json();
      
      if (result.client_schema_name && result.client_schema_name[6]) {
        setProfileData(result.client_schema_name[6][0]);
      }
    } catch (error) {
      console.error('Error fetching profile:', error);
    } finally {
      setLoading(false);
    }
  };

  const validateNewPassword = (password) => {
    if (!password) return "Password cannot be empty";
    if (password.length < 6)
      return "Password must be at least 6 characters long";
    if (!/[A-Z]/.test(password))
      return "Password must contain at least 1 uppercase letter";
    if (!/[a-z]/.test(password))
      return "Password must contain at least 1 lowercase letter";
    if (!/[0-9]/.test(password))
      return "Password must contain at least 1 number";
    if (!/[!@#$%^&*]/.test(password))
      return "Password must contain at least 1 special character (!@#$%^&*)";
    return null; // valid
  };

  const handlePasswordChange = (field, value) => {
    setPasswordData(prev => ({ ...prev, [field]: value }));
    setPasswordError('');
    setSuccessMessage('');
    
    // Validate new password in real-time
    if (field === 'newPassword') {
      const validationError = validateNewPassword(value);
      setNewPasswordError(validationError || '');
    }
  };

  const handleEditPassword = () => {
    setIsEditingPassword(true);
    setPasswordError('');
    setNewPasswordError('');
    setSuccessMessage('');
  };

  const handleCancelEdit = () => {
    setIsEditingPassword(false);
    setPasswordData({
      currentPassword: '',
      newPassword: '',
      confirmPassword: ''
    });
    setPasswordError('');
    setNewPasswordError('');
    setSuccessMessage('');
  };

  const handleLogout = async () => {
    try {
      const userId = localStorage.getItem("userId");
      const clientId = localStorage.getItem("clientId");

      if (userId && clientId) {
        const url = `${API_BASE_URL}/coaching-collaborator-api/api/v1/logout-web?user_id=${encodeURIComponent(userId)}&client_id=${encodeURIComponent(clientId)}`;

        const res = await fetch(url, {
          method: "PUT",
          headers: {
            accept: "application/json",
          },
        });

        try {
          const data = await res.json();
          // Optionally, check data.status === 200
        } catch (_) {
          // Ignore JSON parse issues
        }
      }
    } catch (e) {
      // Ignore network errors and proceed to cleanup
    } finally {
      // Clear all relevant localStorage items
      localStorage.removeItem("isLoggedIn");
      localStorage.removeItem("userId");
      localStorage.removeItem("clientId");
      localStorage.removeItem("clientBranchId");
      localStorage.removeItem("pagePath");
      localStorage.removeItem("auth");

      // OAuth-related keys if present
      localStorage.removeItem("other");
      localStorage.removeItem("other_type");
      localStorage.removeItem("other_expires_in");

      // Any additional app-specific caches
      localStorage.removeItem("ipInfo");

      // Update UI state
      setAuthenticated(false);
      setIsLoggedOut(true);
      // Optional: reset page path preference
      localStorage.setItem("pagePath", "Home");
    }
  };

  const handleSavePassword = async () => {
    // Validation
    if (!passwordData.currentPassword || !passwordData.newPassword || !passwordData.confirmPassword) {
      setPasswordError('All fields are required');
      return;
    }

     // Prevent same password reuse
    if (passwordData.currentPassword === passwordData.newPassword) {
      setPasswordError('New password cannot be the same as current password');
      return;
    }

    // Validate new password
    const newPasswordValidation = validateNewPassword(passwordData.newPassword);
    if (newPasswordValidation) {
      setNewPasswordError(newPasswordValidation);
      return;
    }

    if (passwordData.newPassword !== passwordData.confirmPassword) {
      setPasswordError('New password and confirm password do not match');
      return;
    }

    setSaving(true);
    setPasswordError('');
    setSuccessMessage('Saving...')

    try {
      const token = localStorage.getItem('other');
      const userId = profileData?.user_id ?? 4;
      const clientId = profileData?.client_id ?? 1;
      const modifiedBy = profileData?.user_name ?? 'user';

      // const response = await fetch(
      //   `${EndPoints.PRISM_CHANGE_PASSWORD}?user_id=${userId}&client_id=${clientId}&old_password=${encodeURIComponent(passwordData.currentPassword)}&new_password=${encodeURIComponent(passwordData.newPassword)}&modified_by=${modifiedBy}`,
      //   {
      //     method: 'PATCH',
      //     headers: {
      //       accept: 'application/json',
      //       Authorization: `Bearer ${token}`,
      //     },
      //   }
      // );

      const response = await fetch(`${EndPoints.PRISM_CHANGE_PASSWORD}`, {
        method: 'PATCH',
        headers: {
          accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          user_id: userId,
          client_id: clientId,
          old_password: passwordData.currentPassword,
          new_password: passwordData.newPassword,
          modified_by: modifiedBy,
        }),
      });

      const result = await response.json();

      if (result.status === 200) {
        setSuccessMessage('Password changed successfully! Logging out...');
        setTimeout(() => {
          handleLogout();
        }, 1500);
      } else {
        setPasswordError(result.message || 'Failed to change password');
      }
    } catch (error) {
      console.error('Error changing password:', error);
      setPasswordError('An error occurred while changing password');
    } finally {
      setSaving(false);
    }
  };

  const getFullName = () => {
    if (!profileData) return '';
    const parts = [
      profileData.emp_first_name,
      profileData.emp_middle_name,
      profileData.emp_last_name
    ].filter(Boolean);
    return parts.join(' ');
  };

  const getInitials = () => {
    if (!profileData) return 'U';
    const firstName = profileData.emp_first_name || '';
    const lastName = profileData.emp_last_name || '';
    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
  };

  const getProfileImageUrl = () => {
    return profileData?.profile_image || profileData?.profile_picture || profileData?.avatar_url || null;
  };

  return (
    <div style={styles.container}>
      <style>{`
        .profile-card {
          background-color: #f3f4f6;
          border: 1px solid #d1d5db;
          border-radius: 8px;
          padding: 24px;
          margin-bottom: 16px;
          position: relative;
        }
        .profile-card:first-child {
          margin-top: 60px;
        }
        .input-field-profile {
          width: 100%;
          background-color: white;
          border: 1px solid #d1d5db;
          border-radius: 4px;
          padding: 8px 12px;
          font-size: 14px;
          color: #6A6A6A;
        }
        .input-field-profile:focus {
          outline: none;
        }
        .input-field-profile.error {
          border-color: #ef4444;
        }
        .error-message-profile-page {
          color: #ef4444;
          font-size: 12px;
          margin-top: 4px;
          display: block;
        }
        .success-message {
          color: #10b981;
          font-size: 12px;
          margin-top: 4px;
        }
        .profile-avatar {
          width: 100px;
          height: 100px;
          border-radius: 50%;
          background: var(--ProfileAvatarBackground);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 36px;
          font-weight: 600;
          color: white;
          overflow: hidden;
          border: 4px solid white;
          position: absolute;
          top: -50px;
          left: 24px;
        }
        .profile-avatar img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .profile-edit-icon {
          position: absolute;
          top: 24px;
          right: 24px;
          cursor: pointer;
        }
      `}</style>

      <div style={styles.content}>
        {loading ? (
          <div style={styles.emptyState}>
            <p>Loading profile...</p>
          </div>
        ) : (
          <>
            {/* Profile Information Card */}
            <div className="profile-card">
              <div style={styles.profileHeader}>
                <div style={styles.profileLeft}>
                  <div className="profile-avatar">
                    {getProfileImageUrl() ? (
                      <img src={getProfileImageUrl()} alt="Profile" />
                    ) : (
                      getInitials()
                    )}
                  </div>
                  <div style={styles.profileInfo}>
                    <h2 style={styles.profileName}>{getFullName()}</h2>
                    <div style={styles.profileDetails}>
                      <div style={styles.detailRow}>
                        <span style={styles.detailLabel}>Staff Number:</span>
                        <span style={styles.detailValue}>{profileData?.staff_number}</span>
                      </div>
                      <div style={styles.detailRow}>
                        <span style={styles.detailLabel}>Username:</span>
                        <span style={styles.detailValue}>{profileData?.user_name}</span>
                      </div>
                      <div style={styles.detailRow}>
                        <span style={styles.detailLabel}>Designation:</span>
                        <span style={styles.detailValue}>-</span>
                      </div>
                      <div style={styles.detailRow}>
                        <span style={styles.detailLabel}>Department:</span>
                        <span style={styles.detailValue}>-</span>
                      </div>
                      <div style={styles.detailRow}>
                        <span style={styles.detailLabel}>Manager Name:</span>
                        <span style={styles.detailValue}>-</span>
                      </div>
                      <div style={styles.detailRow}>
                        <span style={styles.detailLabel}>Mobile Number:</span>
                        <span style={styles.detailValue}>-</span>
                      </div>
                      <div style={styles.detailRow}>
                        <span style={styles.detailLabel}>Email:</span>
                        <span style={styles.detailValue}>-</span>
                      </div>
                      <div style={styles.detailRow}>
                        <span style={styles.detailLabel}>Base Branch:</span>
                        <span style={styles.detailValue}>{profileData?.br_display_name}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Change Password Card */}
            <div className="profile-card">
              <div style={styles.cardContent}>
                <div style={styles.cardLeft}>
                  <h3 style={styles.cardTitle}>Change Password</h3>
                  <p style={styles.cardSubtitle}>Update your account password</p>
                   {/* {isEditingPassword ? (
                    <div style={styles.editContainer}>
                      <div style={styles.inputGroup}>
                        <label style={styles.label}>Current Password</label>
                        <input
                          type="password"
                          value={passwordData.currentPassword}
                          onChange={(e) => handlePasswordChange('currentPassword', e.target.value)}
                          className="input-field-profile"
                          placeholder="Enter current password"
                          autoComplete="new-password"
                        />
                      </div>
                      
                      <div style={styles.inputGroup}>
                        <label style={styles.label}>New Password</label>
                        <input
                          type="password"
                          value={passwordData.newPassword}
                          onChange={(e) => handlePasswordChange('newPassword', e.target.value)}
                          className={`input-field-profile ${newPasswordError ? 'error' : ''}`}
                          placeholder="Enter new password"
                          autoComplete="new-password"
                        />
                        {newPasswordError && (
                          <div className="error-message-profile-page">
                            {newPasswordError}
                          </div>
                        )}
                      </div>

                      <div style={styles.inputGroup}>
                        <label style={styles.label}>Confirm Password</label>
                        <input
                          type="text"
                          value={passwordData.confirmPassword}
                          onChange={(e) => handlePasswordChange('confirmPassword', e.target.value)}
                          className={`input-field-profile ${passwordData.confirmPassword && passwordData.newPassword && passwordData.confirmPassword !== passwordData.newPassword ? 'error' : ''}`}
                          placeholder="Confirm new password"
                          autoComplete="off"
                        />
                        {passwordData.confirmPassword && passwordData.newPassword && 
                         passwordData.confirmPassword !== passwordData.newPassword && (
                          <div className="error-message-profile-page">
                            Passwords do not match
                          </div>
                        )}
                      </div>

                      {passwordError && (
                        <div className="error-message-profile-page" style={{ marginTop: '-8px' }}>{passwordError}</div>
                      )}
                      
                      {successMessage && (
                        <div className="success-message">{successMessage}</div>
                      )}

                      <div style={styles.buttonGroup}>
                        <button
                          onClick={handleSavePassword}
                          disabled={saving || !passwordData.currentPassword || 
                                   !passwordData.newPassword || !passwordData.confirmPassword ||
                                   passwordData.newPassword !== passwordData.confirmPassword ||
                                   !!newPasswordError}
                          className="create-test-section-btn"
                          style={{marginLeft: '0px', marginRight: '0px'}}
                        >
                         
                          SAVE
                        </button>
                        <button
                          onClick={handleCancelEdit}
                          disabled={saving}
                          className="create-test-section-btn"
                          style={{marginLeft: '0px', marginRight: '0px'}}
                        >
                          CANCEL
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div style={styles.valueDisplay}>
                      <span style={styles.valueText}>••••••••</span>
                    </div>
                  )} */}
                 {isEditingPassword ? (
                    <div style={styles.editContainer}>
                      <div style={styles.inputGroup}>
                        <label style={styles.label}>Current Password</label>
                        <div style={{ position: "relative" }}>
                          <input
                            type={showCurrentPassword ? "text" : "password"}
                            value={passwordData.currentPassword}
                            onChange={(e) =>
                              handlePasswordChange("currentPassword", e.target.value)
                            }
                            className="input-field-profile"
                            placeholder="Enter current password"
                            autoComplete="off"
                          />
                          <span
                            onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                            style={{
                              position: "absolute",
                              right: "10px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              cursor: "pointer",
                              color: "#6b7280",
                            }}
                          >
                            {showCurrentPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                          </span>
                        </div>
                      </div>

                      {/* New Password */}
                      <div style={styles.inputGroup}>
                        <label style={styles.label}>New Password</label>
                        <div style={{ position: "relative" }}>
                          <input
                            type={showNewPassword ? "text" : "password"}
                            value={passwordData.newPassword}
                            onChange={(e) =>
                              handlePasswordChange("newPassword", e.target.value)
                            }
                            className={`input-field-profile ${newPasswordError ? "error" : ""}`}
                            placeholder="Enter new password"
                            autoComplete="new-password"
                          />
                          <span
                            onClick={() => setShowNewPassword(!showNewPassword)}
                            style={{
                              position: "absolute",
                              right: "10px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              cursor: "pointer",
                              color: "#6b7280",
                            }}
                          >
                            {showNewPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                          </span>
                        </div>
                        {newPasswordError && (
                          <div className="error-message-profile-page">{newPasswordError}</div>
                        )}
                      </div>

                      {/* Confirm Password */}
                      <div style={styles.inputGroup}>
                        <label style={styles.label}>Confirm Password</label>
                        <div style={{ position: "relative" }}>
                          <input
                            type={showConfirmPassword ? "text" : "password"}
                            value={passwordData.confirmPassword}
                            onChange={(e) =>
                              handlePasswordChange("confirmPassword", e.target.value)
                            }
                            className={`input-field-profile ${
                              passwordData.confirmPassword &&
                              passwordData.newPassword &&
                              passwordData.confirmPassword !== passwordData.newPassword
                                ? "error"
                                : ""
                            }`}
                            placeholder="Confirm new password"
                            autoComplete="off"
                          />
                          <span
                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                            style={{
                              position: "absolute",
                              right: "10px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              cursor: "pointer",
                              color: "#6b7280",
                            }}
                          >
                            {showConfirmPassword ? (
                              <AiOutlineEyeInvisible />
                            ) : (
                              <AiOutlineEye />
                            )}
                          </span>
                        </div>
                        {passwordData.confirmPassword &&
                          passwordData.newPassword &&
                          passwordData.confirmPassword !== passwordData.newPassword && (
                            <div className="error-message-profile-page">
                              Passwords do not match
                            </div>
                          )}
                      </div>
                      <div style={{ minHeight: "16px" }}>
                      {passwordError && (
                        <div
                          className="error-message-profile-page"
                          style={{ marginTop: "-8px" }}
                        >
                          {passwordError}
                        </div>
                      )}
                      </div>
                      
                      {successMessage && (
                        <div className="success-message">{successMessage}</div>
                      )}

                      <div style={styles.buttonGroup}>
                        <button
                          onClick={handleSavePassword}
                          disabled={
                            saving ||
                            !passwordData.currentPassword ||
                            !passwordData.newPassword ||
                            !passwordData.confirmPassword ||
                            passwordData.newPassword !== passwordData.confirmPassword ||
                            !!newPasswordError
                          }
                          className="create-test-section-btn"
                          style={{ marginLeft: "0px", marginRight: "0px" }}
                        >
                          SAVE
                        </button>
                        <button
                          onClick={handleCancelEdit}
                          disabled={saving}
                          className="create-test-section-btn"
                          style={{ marginLeft: "0px", marginRight: "0px" }}
                        >
                          CANCEL
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div style={styles.valueDisplay}>
                      <span style={styles.valueText}>••••••••</span>
                    </div>
                  )}
                </div>

                {!isEditingPassword && (
                  <span
                    onClick={handleEditPassword}
                    style={{ cursor: 'pointer' }}
                    title="Change password"
                  >
                    <img src={EditIcon} alt="Edit" />
                  </span>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: 'white',
    color: '#1f2937',
    paddingLeft: '40px',
  },
  content: {
    maxWidth: '1200px',
    paddingTop: '30px',
    paddingLeft: '20px',
  },
  emptyState: {
    textAlign: 'center',
    color: '#6b7280',
    padding: '48px 0',
  },
  profileHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
  },
  profileLeft: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    width: '100%',
  },
  profileInfo: {
    flex: 1,
    marginTop: '50px',
  },
  profileName: {
    fontSize: '24px',
    fontWeight: '600',
    color: '#1f2937',
    marginBottom: '16px',
  },
  profileDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  detailRow: {
    display: 'flex',
    gap: '8px',
    fontSize: '14px',
  },
  detailLabel: {
    fontWeight: '500',
    color: '#6b7280',
    minWidth: '120px',
  },
  detailValue: {
    color: '#1f2937',
  },
  cardContent: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
  },
  cardLeft: {
    flex: 1,
  },
  cardTitle: {
    fontSize: '18px',
    fontWeight: '500',
    color: '#1f2937',
    marginBottom: '8px',
  },
  cardSubtitle: {
    fontSize: '14px',
    color: '#6b7280',
    marginBottom: '16px',
  },
  editContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    maxWidth: '400px',
  },
  inputGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  label: {
    fontSize: '14px',
    fontWeight: '500',
    color: '#374151',
  },
  buttonGroup: {
    display: 'flex',
    gap: '12px',
    marginTop: '8px',
  },
  valueDisplay: {
    fontSize: '14px',
    color: '#374151',
  },
  valueText: {
    fontSize: '20px',
    letterSpacing: '2px',
    color: '#9ca3af',
  },
};

export default Profile;






















































// import { useState, useEffect } from 'react';
// import EditIcon from '../../Assets/Images/CommanImages/GPenz.png';
// import { API_BASE_URL } from "../../Config/Config";
// import ErrorImg from '../../Assets/Images/CommanImages/Error.png';
// import InformImg from '../../Assets/Images/CommanImages/Informative.png';

// const Profile = ({ 
//   setPagePath, 
//   dataClient, 
//   setIsLoggedOut, 
//   setAuthenticated,
//   setMessageBox,
//   messageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   setMessageBoxHeight
// }) => {
//   const [profileData, setProfileData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [isEditingPassword, setIsEditingPassword] = useState(false);
//   const [passwordData, setPasswordData] = useState({
//     currentPassword: '',
//     newPassword: '',
//     confirmPassword: ''
//   });
//   const [passwordError, setPasswordError] = useState('');
//   const [newPasswordError, setNewPasswordError] = useState('');
//   const [saving, setSaving] = useState(false);

//   useEffect(() => {
//     setPagePath('Profile');
//     fetchProfileData();
//   }, []);

//   const fetchProfileData = async () => {
//     setLoading(true);
//     try {
//       const token = localStorage.getItem('other');
//       const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id ?? 1;
//       const userId = dataClient?.client_schema_name?.[6]?.[0]?.user_id ?? 4;

//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/client_landing_page_info_web/?client_id=${clientId}&user_id=${userId}`,
//         {
//           headers: {
//             accept: 'application/json',
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );
//       const result = await response.json();
      
//       if (result.client_schema_name && result.client_schema_name[6]) {
//         setProfileData(result.client_schema_name[6][0]);
//       }
//     } catch (error) {
//       console.error('Error fetching profile:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const validateNewPassword = (password) => {
//     if (!password) return "Password cannot be empty";
//     if (password.length < 6)
//       return "Password must be at least 6 characters long";
//     if (!/[A-Z]/.test(password))
//       return "Password must contain at least 1 uppercase letter";
//     if (!/[a-z]/.test(password))
//       return "Password must contain at least 1 lowercase letter";
//     if (!/[0-9]/.test(password))
//       return "Password must contain at least 1 number";
//     if (!/[!@#$%^&*]/.test(password))
//       return "Password must contain at least 1 special character (!@#$%^&*)";
//     return null; // valid
//   };

//   const handlePasswordChange = (field, value) => {
//     setPasswordData(prev => ({ ...prev, [field]: value }));
//     setPasswordError('');
    
//     // Validate new password in real-time
//     if (field === 'newPassword') {
//       const validationError = validateNewPassword(value);
//       setNewPasswordError(validationError || '');
//     }
//   };

//   const handleEditPassword = () => {
//     setIsEditingPassword(true);
//     setPasswordError('');
//     setNewPasswordError('');
//   };

//   const handleCancelEdit = () => {
//     setIsEditingPassword(false);
//     setPasswordData({
//       currentPassword: '',
//       newPassword: '',
//       confirmPassword: ''
//     });
//     setPasswordError('');
//     setNewPasswordError('');
//   };

//   const handleLogout = async () => {
//     try {
//       const userId = localStorage.getItem("userId");
//       const clientId = localStorage.getItem("clientId");

//       if (userId && clientId) {
//         const url = `${API_BASE_URL}/coaching-collaborator-api/api/v1/logout-web?user_id=${encodeURIComponent(userId)}&client_id=${encodeURIComponent(clientId)}`;

//         const res = await fetch(url, {
//           method: "POST",
//           headers: {
//             accept: "application/json",
//           },
//         });

//         try {
//           const data = await res.json();
//           // Optionally, check data.status === 200
//         } catch (_) {
//           // Ignore JSON parse issues
//         }
//       }
//     } catch (e) {
//       // Ignore network errors and proceed to cleanup
//     } finally {
//       // Clear all relevant localStorage items
//       localStorage.removeItem("isLoggedIn");
//       localStorage.removeItem("userId");
//       localStorage.removeItem("clientId");
//       localStorage.removeItem("clientBranchId");
//       localStorage.removeItem("pagePath");
//       localStorage.removeItem("auth");

//       // OAuth-related keys if present
//       localStorage.removeItem("other");
//       localStorage.removeItem("other_type");
//       localStorage.removeItem("other_expires_in");

//       // Any additional app-specific caches
//       localStorage.removeItem("ipInfo");

//       // Update UI state
//       setAuthenticated(false);
//       setIsLoggedOut(true);
//       // Optional: reset page path preference
//       localStorage.setItem("pagePath", "Home");
//     }
//   };

//   const handleSavePassword = async () => {
//     // Validation
//     if (!passwordData.currentPassword || !passwordData.newPassword || !passwordData.confirmPassword) {
//       setPasswordError('All fields are required');
//       return;
//     }

//     // Validate new password
//     const newPasswordValidation = validateNewPassword(passwordData.newPassword);
//     if (newPasswordValidation) {
//       setNewPasswordError(newPasswordValidation);
//       return;
//     }

//     if (passwordData.newPassword !== passwordData.confirmPassword) {
//       setPasswordError('New password and confirm password do not match');
//       return;
//     }

//     setSaving(true);
//     setPasswordError('');

//     // Show saving message
//     setMessageBox("Saving...");
//     setActiveImg(InformImg);
//     setIsMessageBoxVisible(true);
//     setMessageBoxHeight("10vh");

//     try {
//       const token = localStorage.getItem('other');
//       const userId = profileData?.user_id ?? 4;
//       const clientId = profileData?.client_id ?? 1;
//       const modifiedBy = profileData?.user_name ?? 'user';

//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/change-password?user_id=${userId}&client_id=${clientId}&old_password=${encodeURIComponent(passwordData.currentPassword)}&new_password=${encodeURIComponent(passwordData.newPassword)}&modified_by=${modifiedBy}`,
//         {
//           method: 'PATCH',
//           headers: {
//             accept: 'application/json',
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       const result = await response.json();

//       if (result.status === 200) {
//         // Show success message
//         setMessageBox("Password changed successfully! Logging out...");
//         setActiveImg(InformImg);
//         setIsMessageBoxVisible(true);
//         setMessageBoxHeight("10vh");
        
//         setTimeout(() => {
//           setIsMessageBoxVisible(false);
//           // handleLogout();
//         }, 2000);
//       } else {
//         // Show error message
//         setMessageBox(result.message || 'Failed to change password');
//         setActiveImg(ErrorImg);
//         setIsMessageBoxVisible(true);
//         setMessageBoxHeight("10vh");
//         setPasswordError(result.message || 'Failed to change password');
        
//         setTimeout(() => {
//           setIsMessageBoxVisible(false);
//         }, 3000);
//       }
//     } catch (error) {
//       console.error('Error changing password:', error);
      
//       // Show error message
//       setMessageBox('An error occurred while changing password');
//       setActiveImg(ErrorImg);
//       setIsMessageBoxVisible(true);
//       setMessageBoxHeight("10vh");
//       setPasswordError('An error occurred while changing password');
      
//       setTimeout(() => {
//         setIsMessageBoxVisible(false);
//       }, 3000);
//     } finally {
//       setSaving(false);
//     }
//   };

//   const getFullName = () => {
//     if (!profileData) return '';
//     const parts = [
//       profileData.emp_first_name,
//       profileData.emp_middle_name,
//       profileData.emp_last_name
//     ].filter(Boolean);
//     return parts.join(' ');
//   };

//   const getInitials = () => {
//     if (!profileData) return 'U';
//     const firstName = profileData.emp_first_name || '';
//     const lastName = profileData.emp_last_name || '';
//     return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
//   };

//   const getProfileImageUrl = () => {
//     return profileData?.profile_image || profileData?.profile_picture || profileData?.avatar_url || null;
//   };

//   return (
//     <div style={styles.container}>
//       <style>{`
//         .profile-card {
//           background-color: #f3f4f6;
//           border: 1px solid #d1d5db;
//           border-radius: 8px;
//           padding: 24px;
//           margin-bottom: 16px;
//           position: relative;
//         }
//         .profile-card:first-child {
//           margin-top: 60px;
//         }
//         .input-field-profile {
//           width: 100%;
//           background-color: white;
//           border: 1px solid #d1d5db;
//           border-radius: 4px;
//           padding: 8px 12px;
//           font-size: 14px;
//           color: #1f2937;
//         }
//         .input-field-profile:focus {
//           outline: none;
//         }
//         .input-field-profile.error {
//           border-color: #ef4444;
//         }
//         .error-message-profile-page {
//           color: #ef4444;
//           font-size: 12px;
//           margin-top: 4px;
//           display: block;
//         }
//         .profile-avatar {
//           width: 100px;
//           height: 100px;
//           border-radius: 50%;
//           background: #ef4444;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-size: 36px;
//           font-weight: 600;
//           color: white;
//           overflow: hidden;
//           border: 4px solid white;
//           position: absolute;
//           top: -50px;
//           left: 24px;
//         }
//         .profile-avatar img {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//         }
//         .profile-edit-icon {
//           position: absolute;
//           top: 24px;
//           right: 24px;
//           cursor: pointer;
//         }
//       `}</style>

//       <div style={styles.content}>
//         {loading ? (
//           <div style={styles.emptyState}>
//             <p>Loading profile...</p>
//           </div>
//         ) : (
//           <>
//             {/* Profile Information Card */}
//             <div className="profile-card">
//               <div style={styles.profileHeader}>
//                 <div style={styles.profileLeft}>
//                   <div className="profile-avatar">
//                     {getProfileImageUrl() ? (
//                       <img src={getProfileImageUrl()} alt="Profile" />
//                     ) : (
//                       getInitials()
//                     )}
//                   </div>
//                   <div style={styles.profileInfo}>
//                     <h2 style={styles.profileName}>{getFullName()}</h2>
//                     <div style={styles.profileDetails}>
//                       <div style={styles.detailRow}>
//                         <span style={styles.detailLabel}>Staff Number:</span>
//                         <span style={styles.detailValue}>{profileData?.staff_number}</span>
//                       </div>
//                       <div style={styles.detailRow}>
//                         <span style={styles.detailLabel}>Username:</span>
//                         <span style={styles.detailValue}>{profileData?.user_name}</span>
//                       </div>
//                       <div style={styles.detailRow}>
//                         <span style={styles.detailLabel}>Designation:</span>
//                         <span style={styles.detailValue}>-</span>
//                       </div>
//                       <div style={styles.detailRow}>
//                         <span style={styles.detailLabel}>Department:</span>
//                         <span style={styles.detailValue}>-</span>
//                       </div>
//                       <div style={styles.detailRow}>
//                         <span style={styles.detailLabel}>Manager Name:</span>
//                         <span style={styles.detailValue}>-</span>
//                       </div>
//                       <div style={styles.detailRow}>
//                         <span style={styles.detailLabel}>Mobile Number:</span>
//                         <span style={styles.detailValue}>-</span>
//                       </div>
//                       <div style={styles.detailRow}>
//                         <span style={styles.detailLabel}>Email:</span>
//                         <span style={styles.detailValue}>-</span>
//                       </div>
//                       <div style={styles.detailRow}>
//                         <span style={styles.detailLabel}>Base Branch:</span>
//                         <span style={styles.detailValue}>{profileData?.br_display_name}</span>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Change Password Card */}
//             <div className="profile-card">
//               <div style={styles.cardContent}>
//                 <div style={styles.cardLeft}>
//                   <h3 style={styles.cardTitle}>Change Password</h3>
//                   <p style={styles.cardSubtitle}>Update your account password</p>

//                   {isEditingPassword ? (
//                     <div style={styles.editContainer}>
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>Current Password</label>
//                         <input
//                           type="password"
//                           value={passwordData.currentPassword}
//                           onChange={(e) => handlePasswordChange('currentPassword', e.target.value)}
//                           className="input-field-profile"
//                           placeholder="Enter current password"
//                           autoComplete="new-password"
//                         />
//                       </div>
                      
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>New Password</label>
//                         <input
//                           type="password"
//                           value={passwordData.newPassword}
//                           onChange={(e) => handlePasswordChange('newPassword', e.target.value)}
//                           className={`input-field-profile ${newPasswordError ? 'error' : ''}`}
//                           placeholder="Enter new password"
//                           autoComplete="new-password"
//                         />
//                         {newPasswordError && (
//                           <div className="error-message-profile-page">
//                             {newPasswordError}
//                           </div>
//                         )}
//                       </div>

//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>Confirm Password</label>
//                         <input
//                           type="text"
//                           value={passwordData.confirmPassword}
//                           onChange={(e) => handlePasswordChange('confirmPassword', e.target.value)}
//                           className={`input-field-profile ${passwordData.confirmPassword && passwordData.newPassword && passwordData.confirmPassword !== passwordData.newPassword ? 'error' : ''}`}
//                           placeholder="Confirm new password"
//                           autoComplete="off"
//                         />
//                         {passwordData.confirmPassword && passwordData.newPassword && 
//                          passwordData.confirmPassword !== passwordData.newPassword && (
//                           <div className="error-message-profile-page">
//                             Passwords do not match
//                           </div>
//                         )}
//                       </div>

//                       {passwordError && (
//                         <div className="error-message-profile-page" style={{ marginTop: '-8px' }}>{passwordError}</div>
//                       )}

//                       <div style={styles.buttonGroup}>
//                         <button
//                           onClick={handleSavePassword}
//                           disabled={saving || !passwordData.currentPassword || 
//                                    !passwordData.newPassword || !passwordData.confirmPassword ||
//                                    passwordData.newPassword !== passwordData.confirmPassword ||
//                                    !!newPasswordError}
//                           className="create-test-section-btn"
//                           style={{marginLeft: '0px', marginRight: '0px'}}
//                         >
//                           {/* {saving ? 'SAVING...' : 'SAVE'} */}
//                           SAVE
//                         </button>
//                         <button
//                           onClick={handleCancelEdit}
//                           disabled={saving}
//                           className="create-test-section-btn"
//                           style={{marginLeft: '0px', marginRight: '0px'}}
//                         >
//                           CANCEL
//                         </button>
//                       </div>
//                     </div>
//                   ) : (
//                     <div style={styles.valueDisplay}>
//                       <span style={styles.valueText}>••••••••</span>
//                     </div>
//                   )}
//                 </div>

//                 {!isEditingPassword && (
//                   <span
//                     onClick={handleEditPassword}
//                     style={{ cursor: 'pointer' }}
//                     title="Change password"
//                   >
//                     <img src={EditIcon} alt="Edit" />
//                   </span>
//                 )}
//               </div>
//             </div>
//           </>
//         )}
//       </div>
//     </div>
//   );
// };

// const styles = {
//   container: {
//     minHeight: '100vh',
//     backgroundColor: 'white',
//     color: '#1f2937',
//     paddingLeft: '40px',
//   },
//   content: {
//     maxWidth: '1200px',
//     paddingTop: '30px',
//     paddingLeft: '20px',
//   },
//   emptyState: {
//     textAlign: 'center',
//     color: '#6b7280',
//     padding: '48px 0',
//   },
//   profileHeader: {
//     display: 'flex',
//     alignItems: 'flex-start',
//     justifyContent: 'space-between',
//   },
//   profileLeft: {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '16px',
//     width: '100%',
//   },
//   profileInfo: {
//     flex: 1,
//     marginTop: '50px',
//   },
//   profileName: {
//     fontSize: '24px',
//     fontWeight: '600',
//     color: '#1f2937',
//     marginBottom: '16px',
//   },
//   profileDetails: {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '8px',
//   },
//   detailRow: {
//     display: 'flex',
//     gap: '8px',
//     fontSize: '14px',
//   },
//   detailLabel: {
//     fontWeight: '500',
//     color: '#6b7280',
//     minWidth: '120px',
//   },
//   detailValue: {
//     color: '#1f2937',
//   },
//   cardContent: {
//     display: 'flex',
//     alignItems: 'flex-start',
//     justifyContent: 'space-between',
//   },
//   cardLeft: {
//     flex: 1,
//   },
//   cardTitle: {
//     fontSize: '18px',
//     fontWeight: '500',
//     color: '#1f2937',
//     marginBottom: '8px',
//   },
//   cardSubtitle: {
//     fontSize: '14px',
//     color: '#6b7280',
//     marginBottom: '16px',
//   },
//   editContainer: {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '16px',
//     maxWidth: '400px',
//   },
//   inputGroup: {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '8px',
//   },
//   label: {
//     fontSize: '14px',
//     fontWeight: '500',
//     color: '#374151',
//   },
//   buttonGroup: {
//     display: 'flex',
//     gap: '12px',
//     marginTop: '8px',
//   },
//   valueDisplay: {
//     fontSize: '14px',
//     color: '#374151',
//   },
//   valueText: {
//     fontSize: '20px',
//     letterSpacing: '2px',
//     color: '#9ca3af',
//   },
// };

// export default Profile;